import React from "react";
import FlowsheetObjectService from "../../services/flowsheet-objects.service";
import { FlowsheetObjectModel, FlowsheetObjectType, FlowsheetParameterModel } from "../../swagger-clients/dispatcher-next-api-clients.service";
import { Tooltip, tokens } from "@fluentui/react-components";
import getFlowsheetObjectByParameter from "../paramater-picker-next/parameter-to-flowsheet-objects-maper";

type ParameterDisplayProps = {
    fileUniqueId: string;
    versionNumber: string;
    value: string;
    showTooltip?: boolean;
};


export const ParameterDisplay: React.FC<ParameterDisplayProps> = (props) => {

    const [data, setData] = React.useState<ParameterData>();
    const [showTooltip, setShowTooltip] = React.useState<boolean>(false);

    React.useEffect(() => {
        onInit();
    }, []);

    const onInit = async () => {

        try {
            const { fileUniqueId, versionNumber, value } = props;
            const paramData = await getParameterInfo(fileUniqueId, versionNumber, value);
            setData(paramData);

        } catch (error) {
            console.log("An error occurred while initializing Parameter display component.", error);
        }

    }
    // console.log("unitOperation,stream,component,parameter", unitOperation, stream, component, parameter);
    const { component, parameter, unitOperation, stream, tooltip } = data || {};
    return <Tooltip relationship="description"
        positioning={"above"}
        content={tooltip}
        withArrow
        visible={showTooltip && props.showTooltip && !!tooltip}
        onVisibleChange={(ev, data) => { setShowTooltip(data.visible); }}
    >
        <div style={{ display: "flex", flexDirection: "column", wordBreak: "break-all" }}>
            {unitOperation && <span>
                <span style={{ height: "0.8rem", color: tokens.colorNeutralForeground3 }}>U:</span> {unitOperation.displayName}
            </span>}
            {stream && <span>
                <span style={{ height: "0.8rem", color: tokens.colorNeutralForeground3 }}>S:</span> {stream.displayName}
            </span>}
            {component && <span>
                <span style={{ height: "0.8rem", color: tokens.colorNeutralForeground3 }}>C:</span> {component.displayName}
            </span>}

            {parameter && <span>
                <span style={{ height: "0.8rem", color: tokens.colorNeutralForeground3 }}>P:</span> {parameter.displayName}
                {parameter.unit && <>&nbsp;<span style={{ color: tokens.colorNeutralForeground3 }}>({parameter.unit})</span></>}
            </span>}
        </div>
    </Tooltip>;
}

export const getParameterInfo = async (fileUniqueId: string, versionNumber: string, name: string) => {
    const flowsheetObjects = await FlowsheetObjectService.getFlowsheetObjectsPromise("s365v2", fileUniqueId, versionNumber);
    var objects = getFlowsheetObjectByParameter(name, flowsheetObjects);

    let unitOp, stream, component, parameter, tooltip;

    objects.forEach(o => {
        if ((o as FlowsheetObjectModel).objectType !== undefined) {
            if (o.objectType == FlowsheetObjectType.Component) {
                component = o;
            } else if (o.objectType == FlowsheetObjectType.Stream) {
                stream = o;
            } else if (o.objectType == FlowsheetObjectType.UnitOp) {
                unitOp = o;
            }
        }
        else if ((o as FlowsheetParameterModel).parameter !== undefined) {

            parameter = o;
            const parameterCasted = o as FlowsheetParameterModel;
            const valueWithUnit = `${parameterCasted.value} ` + (!!parameterCasted.unit ? `${parameterCasted.unit}` : "");
            tooltip = valueWithUnit;
        }
    });
    return {
        parameterUniqueId: name,
        unitOperation: unitOp,
        stream: stream,
        component: component,
        parameter,
        tooltip

    } as ParameterData;
}

export type ParameterData = {
    id?: string;  
    parameterUniqueId: string;
    unitOperation?: FlowsheetObjectModel;
    stream?: FlowsheetObjectModel;
    component?: FlowsheetObjectModel;
    parameter?: FlowsheetParameterModel;
    tooltip?: string | undefined;
}